import { AxiosService } from './axiosService';

export class PointMappingService extends AxiosService {
    async viewEquipmentPoints(buildingId, equipmentId) {
        try {
            const {data} = await this.axios.get(`/data/viewEquipmentPoints`, {
                params: {
                    buildingId,
                    equipmentId
                }
            });
            return data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if ((e)?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }

    // NOTE: like the rest of this service, a swallowed 401 returns null —
    // callers must treat a null result as a failed fetch, never as "no stations".
    // The Point Mapping page is granted to Pathian Engineer and Engineer, but this
    // endpoint allows only System Administrator and Pathian Technician, so those
    // roles get null here on every group select.
    async getNiagaraStations(groupId) {
        try {
            const {data} = await this.axios.get(`/niagara/stations/${groupId}`);
            return data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if ((e)?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }

    async mapPoint(equipmentPointId, stationHostId, handle) {
        try {
            await this.axios.put(`/dataInspector/equipment/mapPoint`, {
                equipmentPointId,
                stationHostId,
                handle
            });
            return true;
        } catch (e) {
            return false;
        }
    }
}

export const pointMappingService = new PointMappingService();